import { useListQuery } from '@pesto/hooks';
import { Button } from '@pesto/ui';
import { SmartTable } from '@pesto/ui/features/SmartTable/SmartTable';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useListCreditApplicationsQuery, type CreditApplication } from '../../__generated__/graphql/api';
import { IS_PROD } from '../../constants/global-env';
import { routes } from '../../constants/routes';
import { OnboardNewUserModal } from './components/OnboardNewUserModal';
import { useCreditApplicationsConfig } from './hooks/useCreditApplicationsConfig';

export const CreditApplications = () => {
  const navigate = useNavigate();
  const [showOnboardNewUserModal, setShowOnboardNewUserModal] = useState(false);

  const { data, loadingOrReFetching, refetch } = useListQuery({
    queryHook: useListCreditApplicationsQuery,
  });

  const { getListCreditApplicationsColumns, listCreditApplicationsFilterFields, initialTableState } =
    useCreditApplicationsConfig();

  const handleRowClicked = (row: CreditApplication) => {
    navigate(`${routes.creditApplications}/${row.id}`);
  };

  const handleOnboardCompleted = (creditApplicationId: string) => {
    setShowOnboardNewUserModal(false);
    void refetch();
    navigate(`${routes.creditApplications}/${creditApplicationId}`);
  };

  const amountOfRows = data?.listCreditApplications?.pagination.totalRecords;

  const rows = data?.listCreditApplications?.creditApplications ?? [];
  const columns = getListCreditApplicationsColumns(handleRowClicked);

  return (
    <>
      <SmartTable
        title="Credit Applications"
        amountOfRows={amountOfRows}
        rows={rows}
        columns={columns}
        filterFields={listCreditApplicationsFilterFields}
        loading={loadingOrReFetching}
        pageCount={data?.listCreditApplications?.pagination?.totalPages}
        initialState={initialTableState}
        enableDateRangeFilter
        customFilters={
          IS_PROD ? undefined : (
            <Button onClick={() => setShowOnboardNewUserModal(true)} variant="primary">
              Onboard new user
            </Button>
          )
        }
      />
      {!IS_PROD && (
        <OnboardNewUserModal
          isOpen={showOnboardNewUserModal}
          onClose={() => setShowOnboardNewUserModal(false)}
          onCompleted={handleOnboardCompleted}
        />
      )}
    </>
  );
};
